import React from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
} from '@mui/material';

// The section-level properties dialog (show title, new page), opened
// from the section header's tune button. Changes apply live as they are
// made; Close just dismisses.
const SectionPropertiesDialog = ({ open, section, onChange, onClose }: {
    open: boolean,
    section: { show_title?: boolean | null, new_page?: boolean | null },
    onChange: (patch: Partial<{ show_title: boolean, new_page: boolean }>) => void,
    onClose: () => void,
}): React.ReactElement => (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
        <DialogTitle>Section properties</DialogTitle>
        <DialogContent>
            <FormControlLabel
                control={<Checkbox checked={!!section.show_title} onChange={(evt) => onChange({ show_title: evt.target.checked })} />}
                label="Show title"
            />
            <FormControlLabel
                control={<Checkbox checked={!!section.new_page} onChange={(evt) => onChange({ new_page: evt.target.checked })} />}
                label="New page"
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} color="primary">Close</Button>
        </DialogActions>
    </Dialog>
);

export default SectionPropertiesDialog;
